import { render, staticRenderFns } from "./TiskPracovnichPrukazek.vue?vue&type=template&id=c88a18d4&"
import script from "./TiskPracovnichPrukazek.vue?vue&type=script&lang=ts&"
export * from "./TiskPracovnichPrukazek.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports